module.exports = __webpack_public_path__ + "static/media/edit.462e1d99.svg";